/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link, useNavigate, useParams} from 'react-router-dom'
import { deleteDoc, doc, getDoc, updateDoc} from 'firebase/firestore'
import db from '../../../../services/firebase'
import {useAuth} from '../../../modules/auth'
import AddTask from './submodal/AddTask'
import AddFramework from './submodal/AddFramework'
import AddAutomated from './submodal/AddAutomated'
import AddEvidence from './submodal/AddEvidence'
import AddRiskScenario from './submodal/AddRiskScenario'
import {Helmet} from 'react-helmet'
import UpgradePlanTest from './submodal/UpgradePlanTest'
import {ToastContainer} from 'react-toastify'
import {
  getPersonnels,
  processControlValues,
  deleteNote,
  deletePlatform,
  deleteTest,
  calculateDocumentStatus,
} from '../utils/controlUtils'
import ConfirmationModal from 'app/components/ConfirmationModal'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import Button from 'app/components/Button'
import useAuditContext from 'app/Hooks/useAuditContext'
import {
  useActivities,
  useAudits,
  useControlStatusUpdate,
  useControlTests,
  useLoadControls,
  useUpdateControlDocument,
  useUpdateControlTest,
  getFormattedDateTime,
  handleOwnerAssignment
} from '../utils/controlHooks'

const DetailControl = () => {
  var {id} = useParams()
  const [personnels, setPersonnels] = useState<any[]>([])
  const {currentUser} = useAuth()
  const [newOwner, setNewOwner] = useState('')
  const [activeTab, setActiveTab] = useState('overview')
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [noteInput, setNoteInput] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingNoteIndex, setEditingNoteIndex] = useState(null)
  const [editedNoteContent, setEditedNoteContent] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [showAutomated, setShowAutomated] = useState(false)
  const [showEvidence, setShowEvidence] = useState(false)
  const [isModalRisk, setIsModalRisk] = useState(false)
  const navigate = useNavigate()
  const [showModal2, setShowModal2] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isNoteDeleteModalOpen, setIsNoteDeleteModalOpen] = useState(false)
  const [isTestDeleteModalOpen, setIsTestDeleteModalOpen] = useState(false)
  const [isPlatformDeleteModalOpen, setIsPlatformDeleteModalOpen] = useState(false)
  const [selectedNoteIndex, setSelectedNoteIndex] = useState<number | null>(null)
  const [selectedTestIndex, setSelectedTestIndex] = useState<number | null>(null)
  const [selectedPlatformIndex, setSelectedPlatformIndex] = useState<number | null>(null)
  const [selectedRisk, setSelectedRisk] = useState<any>(null)
  const [isControlDeleteModalOpen, setIsControlDeleteModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedTask, setSelectedTask] = useState<any>(null)
  const [showDeactivated, setShowDeactivated] = useState(false)
  const [noteSaving, setNoteSaving] = useState(false)
  const [isAdding, setIsAdding] = useState(false)
  const {currentAuditContext} = useAuditContext()

  const {tasks, getActivities} = useActivities(currentUser)
  const {audits} = useAudits(currentUser, currentAuditContext)
  const {controls, tests, loadControls} = useLoadControls(id || '', currentUser)
  const {specificTests, specificdocuments, deactivatedCount} = useControlTests(
    id || '',
    controls,
    tests,
    showDeactivated
  )

  useControlStatusUpdate(id || '', controls, currentUser, specificTests, specificdocuments)
  useUpdateControlDocument(id || '', currentUser, specificdocuments)
  useUpdateControlTest(id || '', currentUser, specificTests)

  useEffect(() => {
    getActivities()
  }, [])

  useEffect(() => {
    getPersonnels(currentUser, setPersonnels)
  }, [])

  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }

  const handleOwner = async (event) => {
    if (!id) return
    await handleOwnerAssignment(event, id, currentUser, setNewOwner, personnels)
  }

  const findPersonnelByOwner = (ownerName) => {
    return personnels.find(person => person.full_name === ownerName)
  }

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }

  const handleNotes = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!noteInput.trim() || !id) {
      return
    }

    const {formattedDate, formattedTime} = getFormattedDateTime()
    
    try {
      const tenantId = currentUser?.tenantId || ''
      const controlDocRef = doc(db, `tenants/${tenantId}/controls/${id}`)

      const docSnap = await getDoc(controlDocRef)
      const currentNotes = docSnap.data()?.notes || []

      const assignedAuditId = currentAuditContext?.auditId || (currentUser?.role === 'Auditor' && audits.length > 0 ? audits[0]?.id : '')
      
      const newNoteObject = {
        addedUser: currentUser?.userName || 'Unknown User',
        addedUserUid: currentUser?.uid || '',
        addedDate: formattedDate,
        addedTime: formattedTime,
        note: noteInput.trim(),
        auditId: assignedAuditId,
      }
      setIsAdding(true)
      const updatedNotes = [newNoteObject, ...currentNotes]

    await updateDoc(controlDocRef, {
      notes: updatedNotes,
    })
    showSuccessToast({message: 'Note added successfully'})
    setNoteInput('')
    setIsAdding(false)
    } catch (error) {
      showErrorToast({message: 'Failed to add note'})
      setIsAdding(false)
    }
  }

  const handleRemoveTask = (taskId) => {
    setSelectedTask(taskId)
    setIsDeleteModalOpen(true)
  }

  const handleConfirmTaskDelete = async () => {
    try {
      setIsDeleting(true)
      const tenantId = currentUser?.tenantId || ''
      const taskRef = doc(db, 'tenants', tenantId, 'tasklists', selectedTask)
      await deleteDoc(taskRef)
      getActivities()
      showSuccessToast({message: 'Task has been removed successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while removing the task.'})
    } finally {
      setIsDeleting(false)
      setIsDeleteModalOpen(false)
      setSelectedTask(null)
    }
  }

  const handleEditNote = (index, currentContent) => {
    setEditingNoteIndex(index)
    setEditedNoteContent(currentContent)
  }

  const handleSaveEditedNote = async () => {
    if (!id) return
    
    try {
      setNoteSaving(true)
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/controls/${id}`)

      const docSnap = await getDoc(testDocRef)
      const currentNotes = docSnap.data()?.notes || []

      const updatedNotes = currentNotes.map((note, index) =>
        index === editingNoteIndex ? {...note, note: editedNoteContent} : note
      )

      await updateDoc(testDocRef, {
        notes: updatedNotes,
      })

      // Refresh controls to display the edited note immediately
      loadControls()
      setEditingNoteIndex(null)
      setEditedNoteContent('')
      setNoteSaving(false)
    } catch (error) {
      console.error('Error editing note: ', error)
      setNoteSaving(false)
    }
  }

  const handleboard = () => {
    setShowModal(true)
  }

  const handleCloseboard = () => {
    setShowModal(false)
  }

  const handleAutomated = () => {
    setShowAutomated(true)
  }

  const handleCloseAutomated = () => {
    setShowAutomated(false)
  }

  const handleEvidence = () => {
    setShowEvidence(true)
  }

  const handleCloseEvidence = () => {
    setShowEvidence(false)
  }

  const handleDeleteNote = async (index) => {
    setSelectedNoteIndex(index)
    setIsNoteDeleteModalOpen(true)
  }

  const handleConfirmNoteDelete = async () => {
    try {
      setIsDeleting(true)
      if (selectedNoteIndex === null) return
      if (id === undefined) return
      await deleteNote(currentUser, id, selectedNoteIndex)
      showSuccessToast({message: 'Note has been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the note.'})
    } finally {
      setIsDeleting(false)
      setIsNoteDeleteModalOpen(false)
      setSelectedNoteIndex(null)
    }
  }

  const handleDeleteTest = async (index) => {
    setSelectedTestIndex(index)
    setIsTestDeleteModalOpen(true)
  }

  const handleConfirmTestDelete = async () => {
    try {
      setIsDeleting(true)
      if (selectedTestIndex === null) return
      if (id === undefined) return
      await deleteTest(currentUser, id, selectedTestIndex)
      showSuccessToast({message: 'Test document has been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the test document.'})
    } finally {
      setIsDeleting(false)
      setIsTestDeleteModalOpen(false)
      setSelectedTestIndex(null)
    }
  }

  const handleDeletePlatform = async (index) => {
    setSelectedPlatformIndex(index)
    setIsPlatformDeleteModalOpen(true)
  }

  const handleConfirmPlatformDelete = async () => {
    try {
      setIsDeleting(true)
      if (selectedPlatformIndex === null) return
      if (id === undefined) return
      await deletePlatform(currentUser, id, selectedPlatformIndex)
      showSuccessToast({message: 'Platform test has been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the platform test.'})
    } finally {
      setIsDeleting(false)
      setIsPlatformDeleteModalOpen(false)
      setSelectedPlatformIndex(null)
    }
  }

  const handleOpenRisk = () => {
    setIsModalRisk(true)
  }

  const handleCloseRisk = () => {
    setIsModalRisk(false)
  }

  const handleRiskClick = (riskId) => {
    navigate(`/risk-management?id=${riskId}`)
  }

  const handleDeleteControl = (risk) => {
    setSelectedRisk(risk)
    setIsControlDeleteModalOpen(true)
  }

  const handleConfirmControlDelete = async () => {
    try {
      setIsDeleting(true)
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const riskRef = doc(tenantRef, 'risks', selectedRisk.riskId)
      const controlRef = doc(tenantRef, 'controls', id || '')

      const riskDoc = await getDoc(riskRef)
      if (riskDoc.exists()) {
        const riskData = riskDoc.data()
        const updatedAddedControls = riskData.added_controls.filter((control) => control.id !== id)
        await updateDoc(riskRef, {
          added_controls: updatedAddedControls,
        })
      }

      const controlDoc = await getDoc(controlRef)
      if (controlDoc.exists()) {
        const controlData = controlDoc.data()
        const updatedRiskScenarios = controlData.risk_scenario.filter(
          (scenario) => scenario.riskId !== selectedRisk.riskId
        )
        await updateDoc(controlRef, {
          risk_scenario: updatedRiskScenarios,
        })
      }

      loadControls()
      showSuccessToast({
        message: `"${selectedRisk.riskSource}" has been removed from the risk scenario.`,
      })
    } catch (error) {
      showErrorToast({message: 'An error occurred while removing the risk from the control.'})
    } finally {
      setIsDeleting(false)
      setIsControlDeleteModalOpen(false)
      setSelectedRisk(null)
    }
  }

  return (
    <>
      <Helmet>
        <title>SecureSlate | Controls</title>
      </Helmet>
      <AddFramework id={id || ''} isOpen={showModal} onClose={handleCloseboard} />
      <AddAutomated id={id || ''} isOpen={showAutomated} onClose={handleCloseAutomated} />
      <AddEvidence id={id || ''} isOpen={showEvidence} onClose={handleCloseEvidence} />
      <AddRiskScenario isOpen={isModalRisk} onCancel={handleCloseRisk} controlId={id} />
      {controls.length > 0 ? (
        controls
          .filter((control) => control.id === id)
          .map((control) => (
            <>
              <div className='card px-6 pt-6 mb-4'>
                <div className='d-flex justify-content-between align-items-center mb-2'>
                  <h3 className='mb-0'>{control.control_title}</h3>
                </div>

                <div>
                  <span className='fw-normal fw-bold fs-6'>
                    {control.control_framework_mappings &&
                    typeof control.control_framework_mappings === 'string' ? (
                      <span
                        className='badge px-3 rounded-pill me-2'
                        style={{border: '2px solid #E1E1E1'}}
                      >
                        {control.control_framework_mappings.split(',')[0].trim()}{' '}
                      </span>
                    ) : (
                      ''
                    )}

                    {control.control_framework_mappings &&
                      typeof control.control_framework_mappings === 'string' && (
                        <>
                          {control.control_framework_mappings
                            .split(',')
                            .slice(1)
                            .map((framework, index) => (
                              <span
                                key={index}
                                className='badge px-3  rounded-pill me-2'
                                style={{border: '2px solid #E1E1E1'}}
                              >
                                {framework.trim()}
                              </span>
                            ))}
                        </>
                      )}
                  </span>
                  <span className='fw-normal fs-6 mx-2'>
                    {control.control_evidence_status === 'Deactivated' ? (
                      <a
                        href='#'
                        className='badge fs-7 text-dark text-bold m-1'
                        style={{background: '#F6F6F6'}}
                      >
                        {control.control_evidence_status}
                      </a>
                    ) : (
                      <a
                        className={`badge fs-7 ${
                          control.control_evidence_status === 'Ok' ||
                          control.control_evidence_status === 'OK'
                            ? 'badge-primary'
                            : 'badge-danger'
                        }`}
                        style={{
                          color:
                            control.control_evidence_status === 'Ok' ||
                            control.control_evidence_status === 'OK'
                              ? '#0E9F6E'
                              : '#EE3043',
                          background:
                            control.control_evidence_status === 'Ok' ||
                            control.control_evidence_status === 'OK'
                              ? '#E8F8F4'
                              : '#FFF5F8',
                        }}
                        href='#'
                      >
                        {control.control_evidence_status === 'Ok' ||
                        control.control_evidence_status === 'OK'
                          ? 'OK'
                          : 'Unhealthy'}
                      </a>
                    )}{' '}
                    <span className='mx-1'> </span>
                    <span className='fs-6 text-grey-800 fw-semibold'>
                      {' '}
                      {processControlValues(
                        control.control_document,
                        control.control_test,
                        control.test_id,
                        control.document_id,
                        tests
                      )}{' '}
                      Test Passing
                    </span>
                  </span>
                </div>

                <div className='px-2  mt-4 '>
                  <div className='d-flex  h-55px'>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
                      <li className='nav-item'>
                        <Link
                          to={`/controls/details/${id}`}
                          className={`nav-link me-6 ${
                            activeTab === 'overview' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('overview')}
                        >
                          Tests
                        </Link>
                      </li>

                      <li className='nav-item'>
                        <Link
                          to={`/controls/details/${id}`}
                          className={`nav-link me-6 ${
                            activeTab === 'risks' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('risks')}
                        >
                          Risks
                        </Link>
                      </li>

                      <li className='nav-item'>
                        <Link
                          to={`/controls/details/${id}`}
                          className={`nav-link me-6 ${
                            activeTab === 'notes' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('notes')}
                        >
                          Notes
                        </Link>
                      </li>

                      {/* <li className='nav-item'>
                        <Link
                          to={`/controls/details/${id}`}
                          className={`nav-link me-6 ${
                            activeTab === 'tasks' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('tasks')}
                        >
                          Tasks
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              {activeTab === 'overview' && (
                <>
                  <div className='card mb-5 mb-xl-8 p-6 mt-8'>
                    <div
                      className='fv-row mb-6 text-gray-800 fs-6'
                      dangerouslySetInnerHTML={{__html: control.control_description}}
                    />

                    <div className='row g-5 g-xxl-6'>
                      <div className='col-md-6'>
                        <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                          AUTHOR
                        </h4>
                        <p className='text-grey-800 fw-semibold'>
                          {control.author ? control.author : 'SecureSlate'}
                        </p>

                        <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                          STATUS
                        </h4>
                        <p className='text-grey-800 fw-semibold'>
                          {' '}
                          <span className='fw-normal fs-6 '>
                            <span className='fw-semibold'>
                              {control.control_evidence_status === 'Deactivated' ? (
                                <a
                                  href='#'
                                  className='badge fs-7 text-dark text-bold'
                                  style={{background: '#F6F6F6'}}
                                >
                                  {control.control_evidence_status}
                                </a>
                              ) : (
                                <a
                                  className={`badge fs-7 ${
                                    control.control_evidence_status === 'Ok' ||
                                    control.control_evidence_status === 'OK'
                                      ? 'badge-primary'
                                      : 'badge-danger'
                                  }`}
                                  style={{
                                    color:
                                      control.control_evidence_status === 'Ok' ||
                                      control.control_evidence_status === 'OK'
                                        ? '#0E9F6E'
                                        : '#EE3043',
                                    background:
                                      control.control_evidence_status === 'Ok' ||
                                      control.control_evidence_status === 'OK'
                                        ? '#E8F8F4'
                                        : '#FFF5F8',
                                  }}
                                  href='#'
                                >
                                  {control.control_evidence_status}
                                </a>
                              )}
                            </span>{' '}
                            <span className='fs-6 text-grey-800 fw-semibold'>
                              {' '}
                              {processControlValues(
                                control.control_document,
                                control.control_test,
                                control.test_id,
                                control.document_id,
                                tests
                              )}{' '}
                              Test Passing
                            </span>
                          </span>
                        </p>
                      </div>
                      <div className='col-md-6'>
                        <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                          FRAMEWORKS MAPPED
                        </h4>

                        <p className='text-grey-800 fw-semibold'>
                          {control.control_framework_mappings &&
                          typeof control.control_framework_mappings === 'string' ? (
                            <span
                              className='badge px-3 rounded-pill me-2'
                              style={{border: '2px solid #E1E1E1'}}
                            >
                              {control.control_framework_mappings.split(',')[0].trim()}{' '}
                            </span>
                          ) : (
                            <>--</>
                          )}

                          {control.control_framework_mappings &&
                            typeof control.control_framework_mappings === 'string' && (
                              <>
                                {control.control_framework_mappings
                                  .split(',')
                                  .slice(1)
                                  .map((framework, index) => (
                                    <span
                                      key={index}
                                      className='badge px-3 rounded-pill me-2'
                                      style={{border: '2px solid #E1E1E1'}}
                                    >
                                      {framework.trim()}
                                    </span>
                                  ))}
                              </>
                            )}
                          {control.author === 'Custom Control' && (
                            <button
                              className='btn btn-sm fs-6 p-0'
                              style={{color: '#0E9F6E'}}
                              onClick={handleboard}
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='16'
                                height='16'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='currentColor'
                                stroke-width='2'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                                className='icon icon-tabler icons-tabler-outline icon-tabler-edit me-1 mb-1'
                              >
                                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                                <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                                <path d='M16 5l3 3' />
                              </svg>
                              edit
                            </button>
                          )}
                        </p>

                        <h4 className=' fw-bold fs-6' style={{color: '#5E6274'}}>
                          OWNER
                        </h4>
                        <p className='text-grey-800 fw-semibold'>
                          <span className='fw-normal'>
                            {' '}
                            <select
                              name='group'
                              className='form-select w-40 py-2 px-4'
                              data-control='select2'
                              style={{width: '200px'}}
                              data-placeholder='Select Group'
                              value={newOwner || control.control_owner}
                              onChange={handleOwner}
                              disabled={currentUser?.role === 'Auditor'}
                            >
                              <option value='' defaultChecked>
                                Assign Owner
                              </option>
                              {personnels
                                .filter((user) => user.role === 'Admin' || user.role === 'Owner')
                                .map((group) => (
                                  <option key={group.id} value={group.full_name}>
                                    {group.full_name}
                                  </option>
                                ))}
                            </select>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  {deactivatedCount > 0 && (
                    <div
                      className='card'
                      style={{
                        backgroundColor: 'oklch(98.5% 0.002 247.839)',
                        border: '0.2px solid rgb(169, 172, 176)',
                        marginBottom: '24px',
                      }}
                    >
                      <div className='px-6 py-4'>
                        <div className='d-flex align-items-between justify-content-between'>
                          <div className='d-flex justify-content-center align-content-center flex-column gap-1'>
                            <span className='card-label  fs-6'>
                              {' '}
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='20'
                                height='20'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='#5E6274'
                                stroke-width='2'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                                className='icon icon-tabler icons-tabler-outline icon-tabler-clock-pause me-3'
                              >
                                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                <path d='M20.942 13.018a9 9 0 1 0 -7.909 7.922' />
                                <path d='M12 7v5l2 2' />
                                <path d='M17 17v5' />
                                <path d='M21 17v5' />
                              </svg>
                              {deactivatedCount} {deactivatedCount === 1 ? 'test is' : 'tests are'}
                              deactivated
                            </span>
                          </div>

                          <div className='d-flex align-items-center gap-2'>
                            <div className='form-check form-switch d-flex align-items-center gap-2'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                role='switch'
                                id='showDeactivated'
                                style={{
                                  cursor: 'pointer',
                                  width: '36px',
                                  height: '20px',
                                  backgroundColor: showDeactivated ? '#0E9F6E' : '#E4E6EF',
                                  borderColor: showDeactivated ? '#0E9F6E' : '#E4E6EF',
                                  marginTop: '0',
                                }}
                                onChange={(e) => setShowDeactivated(e.target.checked)}
                              />
                              <span className='fs-7'>Show Deactivated</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {(() => {
                    const docStatus = calculateDocumentStatus(specificTests, control.test_id)
                    return docStatus === ' N/A ' || docStatus === '0/0' ? (
                      <>
                        <div className='card mb-5 mb-xl-8'>
                          <div className='border-bottom p-6 d-flex justify-content-between align-items-center fw-bold fs-6 mb-6'>
                            <div className='d-flex align-items-center'>
                              <h4 className='mb-0 me-2'>Platform</h4>
                              <span className='text-gray-800 fw-semibold fs-8'>
                                {/* (
                              {control.control_test === '0/0'
                                ? ' N/A '
                                : `${control.control_test} OK`}
                              ) */}
                                (N/A)
                              </span>
                            </div>

                            {control.author === 'Custom Control' && (
                              <button
                                className='btn btn-sm fs-6'
                                onClick={handleAutomated}
                                onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#148363')
                                }
                                onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#0E9F6E')
                                }
                                // disabled={activities.length === 0}
                                style={{
                                  backgroundColor: '#0E9F6E',
                                  color: '#fff',
                                  width: '90px',
                                  height: '40px',
                                  borderRadius: '4px',

                                  transition: 'background-color 0.3s',
                                }}
                              >
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='18'
                                  height='18'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  stroke='currentColor'
                                  stroke-width='2'
                                  stroke-linecap='round'
                                  stroke-linejoin='round'
                                  className='icon icon-tabler icons-tabler-outline icon-tabler-plus mx-1'
                                >
                                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                  <path d='M12 5l0 14' />
                                  <path d='M5 12l14 0' />
                                </svg>
                                Add
                              </button>
                            )}
                          </div>
                          <div className='d-flex align-items-center justify-content-center w-100 py-10 fw-bold'>
                            No tests required for this control
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={`card mb-5 mb-xl-8`}>
                          <div className='border-bottom p-6 d-flex justify-content-between align-items-center fw-bold fs-6'>
                            <div className='d-flex align-items-center'>
                              <h4 className='mb-0 me-2'>Platform</h4>
                              <span className='fw-semibold fs-7'>
                                {' '}
                                {(() => {
                                  const status = calculateDocumentStatus(
                                    specificTests,
                                    control.test_id
                                  )
                                  return status === '0/0' || status === ' N/A '
                                    ? ' N/A '
                                    : `(${status} OK)`
                                })()}
                              </span>
                            </div>
                            {control.author === 'Custom Control' && (
                              <button
                                className='btn btn-sm fs-6'
                                onClick={handleAutomated}
                                onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#148363')
                                }
                                onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#0E9F6E')
                                }
                                style={{
                                  backgroundColor: '#0E9F6E',
                                  color: '#fff',
                                  width: '90px',
                                  height: '40px',
                                  borderRadius: '4px',

                                  transition: 'background-color 0.3s',
                                }}
                              >
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='18'
                                  height='18'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  stroke='currentColor'
                                  stroke-width='2'
                                  stroke-linecap='round'
                                  stroke-linejoin='round'
                                  className='icon icon-tabler icons-tabler-outline icon-tabler-plus mx-1'
                                >
                                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                  <path d='M12 5l0 14' />
                                  <path d='M5 12l14 0' />
                                </svg>
                                Add
                              </button>
                            )}
                          </div>
                          {specificTests.map((test, index) => (
                            <div key={index}>
                              <div className='d-flex align-items-center p-6'>
                                <div className='d-flex justify-content-start flex-column'>
                                  {/* <a
                                  href={`/tests?id=${test.id}`}
                                  target='_blank'
                                  rel='noreferrer'
                                  style={{textDecoration: 'none', color: 'inherit'}}
                                > */}
                                  <div
                                    onClick={() => {
                                      if (currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus') {
                                        window.open(`/tests?id=${test.id}`, '_blank')
                                      } else {
                                        setShowModal2(true)
                                      }
                                    }}
                                    style={{cursor: 'pointer'}}
                                  >
                                    <span className='card-label text-hover-primary fw-bold fs-6'>
                                      {test.name}
                                    </span>
                                  </div>
                                  <span className='text-gray-800 fw-semibold fs-7 d-flex align-items-center my-2'>
                                    Owner:{' '}
                                    {(() => {
                                      const ownerPersonnel = findPersonnelByOwner(test.owner)
                                      return ownerPersonnel ? (
                                        <div className='symbol symbol-25px mx-1'>
                                          {ownerPersonnel.image_url ? (
                                            <img
                                              src={ownerPersonnel.image_url}
                                              alt={ownerPersonnel.full_name}
                                              className='symbol-label fs-7 fw-bold'
                                              style={{
                                                objectFit: 'cover',
                                                width: '25px',
                                                height: '25px'
                                              }}
                                            />
                                          ) : (
                                            <span
                                              className='symbol-label fs-7 fw-bold'
                                              style={{
                                                backgroundColor: '#F5F5F5',
                                                border: '1px solid #E5E5E5',
                                              }}
                                            >
                                              {ownerPersonnel.full_name
                                                ? ownerPersonnel.full_name.charAt(0).toUpperCase()
                                                : ''}
                                            </span>
                                          )}
                                        </div>
                                      ) : test.owner ? (
                                        <div className='symbol symbol-25px mx-1'>
                                          <span
                                            className='symbol-label fs-7 fw-bold'
                                            style={{
                                              backgroundColor: '#F5F5F5',
                                              border: '1px solid #E5E5E5',
                                            }}
                                          >
                                            {test.owner.charAt(0).toUpperCase()}
                                          </span>
                                        </div>
                                      ) : null
                                    })()}
                                    <span className='fw-semibold mx-1'>
                                      {test.owner ? test.owner : 'Not assigned'} |{' '}
                                    </span>
                                    <a
                                      href='#'
                                      className='badge fs-7 ms-1'
                                      style={{
                                        color: test.status === 'Pass' ? '#0E9F6E' : '#EE3043',
                                        background: test.status === 'Pass' ? '#E8F8F4' : '#FFF5F8',
                                      }}
                                    >
                                      {' '}
                                      {test.status === 'Pass' ? 'Passing' : 'Failing'}
                                    </a>
                                  </span>
                                </div>

                                <div className='ms-auto'>
                                  {control.author !== 'Custom Control' ? (
                                    <div
                                      onClick={() => {
                                        if (currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus') {
                                          window.open(`/tests?id=${test.id}`, '_blank')
                                        } else {
                                          setShowModal2(true)
                                        }
                                      }}
                                      style={{cursor: 'pointer'}}
                                    >
                                      <span className='fw-semibold mx-2'>See test details</span>
                                      <img
                                        src={toAbsoluteUrl(`/media/buttons/Chevron Button.svg`)}
                                        alt=''
                                      />
                                    </div>
                                  ) : (
                                    <div className='dropdown'>
                                      <button
                                        className='btn btn-secondary border-0 p-0 m-2'
                                        type='button'
                                        id='dropdownMenu2'
                                        data-bs-toggle='dropdown'
                                        aria-haspopup='true'
                                        aria-expanded='false'
                                      >
                                        <img
                                          src='/media/buttons/Options.svg'
                                          alt='Options'
                                          onClick={toggleDropdown}
                                        />
                                      </button>
                                      <ul
                                        className='dropdown-menu dropdown-menu-end'
                                        aria-labelledby='dropdownMenu2'
                                      >
                                        <li>
                                          <a
                                            className='dropdown-item text-muted text-hover-primary '
                                            type='button'
                                            // onClick={() => handleEditNote(index, note.note)}
                                            href={`/tests?id=${test.id}`}
                                          >
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              width='18'
                                              height='18'
                                              viewBox='0 0 24 24'
                                              fill='none'
                                              stroke='currentColor'
                                              stroke-width='2'
                                              stroke-linecap='round'
                                              stroke-linejoin='round'
                                              className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-2 mb-1'
                                            >
                                              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                              <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                                              <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                                            </svg>
                                            View
                                          </a>
                                        </li>
                                        <li>
                                          <button
                                            className='dropdown-item text-danger'
                                            type='button'
                                            onClick={() => handleDeletePlatform(index)}
                                          >
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              width='18'
                                              height='18'
                                              viewBox='0 0 24 24'
                                              fill='none'
                                              stroke='currentColor'
                                              stroke-width='2'
                                              stroke-linecap='round'
                                              stroke-linejoin='round'
                                              className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                                            >
                                              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                              <path d='M4 7l16 0' />
                                              <path d='M10 11l0 6' />
                                              <path d='M14 11l0 6' />
                                              <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                              <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                            </svg>
                                            Delete
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className='separator'></div>
                            </div>
                          ))}
                        </div>
                      </>
                    )
                  })()}
                  {(() => {
                    const docStatus = calculateDocumentStatus(
                      specificdocuments,
                      control.document_id
                    )
                    return docStatus === ' N/A ' || docStatus === '0/0' ? (
                      <>
                        <div className='card mb-5 mb-xl-8'>
                          <div className='border-bottom p-6 d-flex justify-content-between align-items-center fw-bold fs-6 mb-6'>
                            <div className='d-flex align-items-center'>
                              <h4 className='mb-0 me-2'>Document</h4>
                              <span className='text-gray-800 fw-semibold fs-8'>(N/A)</span>
                            </div>

                            {control.author === 'Custom Control' && (
                              <button
                                className='btn btn-sm fs-6'
                                onClick={handleEvidence}
                                onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#148363')
                                }
                                onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#0E9F6E')
                                }
                                style={{
                                  backgroundColor: '#0E9F6E',
                                  color: '#fff',
                                  width: '90px',
                                  height: '40px',
                                  borderRadius: '4px',

                                  transition: 'background-color 0.3s',
                                }}
                              >
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='18'
                                  height='18'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  stroke='currentColor'
                                  stroke-width='2'
                                  stroke-linecap='round'
                                  stroke-linejoin='round'
                                  className='icon icon-tabler icons-tabler-outline icon-tabler-plus mx-1'
                                >
                                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                  <path d='M12 5l0 14' />
                                  <path d='M5 12l14 0' />
                                </svg>
                                Add
                              </button>
                            )}
                          </div>
                          <div className='d-flex align-items-center justify-content-center w-100 py-10 fw-bold'>
                            No documents for this control
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={`card mb-5 mb-xl-8`}>
                          <div className='border-bottom p-6 d-flex justify-content-between align-items-center fw-bold fs-6'>
                            <div className='d-flex align-items-center'>
                              <h3 className='mb-0 me-2'>Document</h3>
                              <span className='fw-semibold fs-7'>
                                {' '}
                                {(() => {
                                  const status = calculateDocumentStatus(
                                    specificdocuments,
                                    control.document_id
                                  )
                                  return status === '0/0' || status === ' N/A '
                                    ? ' N/A '
                                    : `(${status} OK)`
                                })()}
                              </span>
                            </div>
                            {control.author === 'Custom Control' && (
                              <button
                                className='btn btn-sm fs-6'
                                onClick={handleEvidence}
                                onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#148363')
                                }
                                onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                                  (e.currentTarget.style.backgroundColor = '#0E9F6E')
                                }
                                // disabled={activities.length === 0}
                                style={{
                                  backgroundColor: '#0E9F6E',
                                  color: '#fff',
                                  width: '90px',
                                  height: '40px',
                                  borderRadius: '4px',

                                  transition: 'background-color 0.3s',
                                }}
                              >
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='18'
                                  height='18'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  stroke='currentColor'
                                  stroke-width='2'
                                  stroke-linecap='round'
                                  stroke-linejoin='round'
                                  className='icon icon-tabler icons-tabler-outline icon-tabler-plus mx-1'
                                >
                                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                  <path d='M12 5l0 14' />
                                  <path d='M5 12l14 0' />
                                </svg>
                                Add
                              </button>
                            )}
                          </div>

                          {specificdocuments.map((test, index) => (
                            <React.Fragment key={index}>
                              <div className='p-6 d-flex align-items-center'>
                                <div className='d-flex justify-content-start flex-column'>
                                  <div
                                    onClick={() => {
                                      if (currentUser?.account_type !== 'Trial') {
                                        window.open(`/tests?id=${test.id}`, '_blank')
                                      } else {
                                        setShowModal2(true)
                                      }
                                    }}
                                    style={{cursor: 'pointer'}}
                                  >
                                    <span className='card-label fw-bold fs-6'>{test.name}</span>
                                  </div>
                                  <span className='text-gray-800 fw-semibold fs-7 d-flex align-items-center my-2'>
                                    Owner:{' '}
                                    {(() => {
                                      const ownerPersonnel = findPersonnelByOwner(test.owner)
                                      return ownerPersonnel ? (
                                        <div className='symbol symbol-25px mx-1'>
                                          {ownerPersonnel.image_url ? (
                                            <img
                                              src={ownerPersonnel.image_url}
                                              alt={ownerPersonnel.full_name}
                                              className='symbol-label fs-7 fw-bold'
                                              style={{
                                                objectFit: 'cover',
                                                width: '25px',
                                                height: '25px'
                                              }}
                                            />
                                          ) : (
                                            <span
                                              className='symbol-label fs-7 fw-bold'
                                              style={{
                                                backgroundColor: '#F5F5F5',
                                                border: '1px solid #E5E5E5',
                                              }}
                                            >
                                              {ownerPersonnel.full_name
                                                ? ownerPersonnel.full_name.charAt(0).toUpperCase()
                                                : ''}
                                            </span>
                                          )}
                                        </div>
                                      ) : test.owner ? (
                                        <div className='symbol symbol-25px mx-1'>
                                          <span
                                            className='symbol-label fs-7 fw-bold'
                                            style={{
                                              backgroundColor: '#F5F5F5',
                                              border: '1px solid #E5E5E5',
                                            }}
                                          >
                                            {test.owner.charAt(0).toUpperCase()}
                                          </span>
                                        </div>
                                      ) : null
                                    })()}
                                    <span className='fw-semibold mx-1'>
                                      {test.owner ? test.owner : 'Not assigned'}
                                    </span>
                                    |{' '}
                                    <a
                                      href='#'
                                      className='badge fs-7 ms-2'
                                      style={{
                                        color: test.status === 'Pass' ? '#0E9F6E' : '#EE3043',
                                        background: test.status === 'Pass' ? '#E8F8F4' : '#FFF5F8',
                                      }}
                                    >
                                      {' '}
                                      {test.status === 'Pass' ? 'Passing' : 'Failing'}
                                    </a>
                                  </span>
                                </div>
                                <div className='ms-auto'>
                                  {control.author !== 'Custom Control' ? (
                                    <div
                                      onClick={() => {
                                        if (currentUser?.account_type !== 'Trial') {
                                          window.open(`/tests?id=${test.id}`, '_blank')
                                        } else {
                                          setShowModal2(true)
                                        }
                                      }}
                                      style={{cursor: 'pointer'}}
                                    >
                                      <span className='fw-semibold mx-2'>See test details</span>
                                      <img
                                        src={toAbsoluteUrl(`/media/buttons/Chevron Button.svg`)}
                                        alt=''
                                      />
                                    </div>
                                  ) : (
                                    <div className='dropdown'>
                                      <button
                                        className='btn btn-secondary border-0 p-0 m-2'
                                        type='button'
                                        id='dropdownMenu2'
                                        data-bs-toggle='dropdown'
                                        aria-haspopup='true'
                                        aria-expanded='false'
                                      >
                                        <img
                                          src='/media/buttons/Options.svg'
                                          alt='Options'
                                          onClick={toggleDropdown}
                                        />
                                      </button>
                                      <ul
                                        className='dropdown-menu dropdown-menu-end'
                                        aria-labelledby='dropdownMenu2'
                                      >
                                        <li>
                                          <a
                                            className='dropdown-item text-muted text-hover-primary '
                                            type='button'
                                            href={`/tests?id=${test.id}`}
                                          >
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              width='18'
                                              height='18'
                                              viewBox='0 0 24 24'
                                              fill='none'
                                              stroke='currentColor'
                                              stroke-width='2'
                                              stroke-linecap='round'
                                              stroke-linejoin='round'
                                              className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-2 mb-1'
                                            >
                                              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                              <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                                              <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                                            </svg>
                                            View
                                          </a>
                                        </li>
                                        <li>
                                          <button
                                            className='dropdown-item text-danger'
                                            type='button'
                                            onClick={() => handleDeleteTest(index)}
                                          >
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              width='18'
                                              height='18'
                                              viewBox='0 0 24 24'
                                              fill='none'
                                              stroke='currentColor'
                                              stroke-width='2'
                                              stroke-linecap='round'
                                              stroke-linejoin='round'
                                              className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                                            >
                                              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                              <path d='M4 7l16 0' />
                                              <path d='M10 11l0 6' />
                                              <path d='M14 11l0 6' />
                                              <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                              <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                            </svg>
                                            Delete
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className='separator'></div>
                            </React.Fragment>
                          ))}
                        </div>
                      </>
                    )
                  })()}
                </>
              )}

              {activeTab === 'risks' && (
                <>
                  {' '}
                  <div className='my-4 mt-8 d-flex justify-content-between'>
                    <div className=''>
                      <div className='fs-6 fw-bold mb-2'>Risk Scenarios</div>
                      <span>
                        {control?.risk_scenario ? control?.risk_scenario.length : 0} scenarios
                        mapped to this control
                      </span>
                    </div>
                    {currentUser?.role !== 'Auditor' && (
                      <Button btnType='primary' onClick={handleOpenRisk}>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          stroke-width='2'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          className='icon icon-tabler icons-tabler-outline icon-tabler-plus me-1 mb-1'
                        >
                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                          <path d='M12 5l0 14' />
                          <path d='M5 12l14 0' />
                        </svg>
                        Add Risks
                      </Button>
                    )}
                  </div>
                  <div className='card mt-4'>
                    <div
                      className='table-responsive'
                      style={{minHeight: '100px', maxHeight: '500px', overflowY: 'auto'}}
                    >
                      {control?.risk_scenario && control?.risk_scenario.length > 0 ? (
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-6 gy-6'>
                          <thead>
                            <tr
                              className='fw-bold'
                              style={{background: '#F6F6F6', color: '#5A5A5A'}}
                            >
                              <th className='min-w-200px pe-6'>Scenario</th>
                              <th className='min-w-100px'>Status</th>
                              <th className='min-w-50px'>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {control?.risk_scenario.map((control) => (
                              <tr key={control.riskId} className=' px-6'>
                                <td
                                  className='fs-6 fw-semibold text-hover-primary py-8'
                                  style={{borderBottom: '1px dotted #C5C5C5', cursor: 'pointer'}}
                                  onClick={() => handleRiskClick(control.riskId)}
                                >
                                  {control.riskSource}
                                </td>
                                <td>
                                  {' '}
                                  <span
                                    className={`badge fs-7 ${
                                      control.status === 'Incomplete'
                                        ? 'badge-danger'
                                        : control.status === 'Needs approval'
                                        ? 'badge-warning'
                                        : 'badge-primary'
                                    }`}
                                    style={{
                                      color:
                                        control.status === 'Incomplete'
                                          ? '#EE3043'
                                          : control.status === 'Needs approval'
                                          ? '#FFA800'
                                          : '#0E9F6E',
                                      background:
                                        control.status === 'Incomplete'
                                          ? '#FFF5F8'
                                          : control.status === 'Needs approval'
                                          ? '#FFF8DD'
                                          : '#E8F8F4',
                                    }}
                                  >
                                    {control.status}
                                  </span>
                                </td>
                                <td>
                                  <button
                                    className='btn btn-sm btn-icon btn-secondary ms-2'
                                    onClick={() => handleDeleteControl(control)}
                                    disabled={currentUser?.role === 'Auditor'}
                                    style={{flexShrink: 0}}
                                    onMouseEnter={(e) => {
                                      const svg = e.currentTarget.querySelector('svg')
                                      if (svg) {
                                        svg.style.stroke = 'oklch(57.7% 0.245 27.325)'
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      const svg = e.currentTarget.querySelector('svg')
                                      if (svg) {
                                        svg.style.stroke = 'currentColor'
                                      }
                                    }}
                                  >
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='18'
                                      height='18'
                                      viewBox='0 0 24 24'
                                      fill='none'
                                      stroke='currentColor'
                                      strokeWidth='2'
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                      className='icon icon-tabler icons-tabler-outline icon-tabler-trash'
                                      style={{
                                        transition: 'stroke 0.2s',
                                      }}
                                    >
                                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                      <path d='M4 7l16 0' />
                                      <path d='M10 11l0 6' />
                                      <path d='M14 11l0 6' />
                                      <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                      <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                    </svg>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <>
                          <div
                            className='card-body'
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='24'
                              height='24'
                              viewBox='0 0 24 24'
                              fill='none'
                              stroke='#000'
                              strokeWidth='2'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              className='icon icon-tabler icons-tabler-outline icon-tabler-adjustments-horizontal'
                            >
                              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                              <path d='M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                              <path d='M4 6l8 0' />
                              <path d='M16 6l4 0' />
                              <path d='M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                              <path d='M4 12l2 0' />
                              <path d='M10 12l10 0' />
                              <path d='M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                              <path d='M4 18l11 0' />
                              <path d='M19 18l1 0' />
                            </svg>
                            <br />
                            <span className='fs-6 fw-semibold'>No risks added</span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}

              {activeTab === 'notes' && (
                <>
                  <div className='mb-8 mt-8'>
                    <div className='d-flex align-items-center mb-8'>
                      <textarea
                        // type='text'
                        className='form-control me-2'
                        placeholder='Leave a note'
                        name='notes'
                        value={noteInput}
                        onChange={(e) => setNoteInput(e.target.value)}
                      />
                      {isAdding ? (
                        <Button btnType='primary' disabled>
                          Adding...{' '}
                          <span className='spinner-border spinner-border-sm align-middle m-2'></span>
                        </Button>
                      ) : (
                        <Button
                          btnType='primary'
                          onClick={handleNotes}
                          disabled={!noteInput.trim()}
                        >
                          Add Note
                        </Button>
                      )}
                    </div>
                    {controls && controls.length > 0 ? (
                        controls.map((control) => {
                          const filteredNotes = control.notes ? control.notes.filter((note) => {
                            if (currentAuditContext?.auditId) {
                              return note.auditId === currentAuditContext.auditId
                            }
                            if (currentUser?.role === 'Auditor' && audits.length > 0) {
                              return note.auditId === audits[0]?.id
                            }
                            return !note.auditId
                          }) : []
                          
                          return filteredNotes.length > 0 ? (
                            filteredNotes.map((note, index) => (
                              <div className='mt-4 mb-8' key={index}>
                                <div className='d-flex align-items-center justify-content-between mb-2'>
                                  <div className='d-flex align-items-center'>
                                    <div className='symbol symbol-40px me-3'>
                                      {note.addedUser ? (
                                        <span
                                          className='symbol-label fs-7 fw-bold'
                                          style={{
                                            backgroundColor: '#F5F5F5',
                                            border: '1px solid #E5E5E5',
                                            borderRadius: '50%',
                                          }}
                                        >
                                          {note.addedUser
                                            ? note.addedUser.trim().charAt(0).toUpperCase()
                                            : ''}
                                        </span>
                                      ) : (
                                        <span>-</span>
                                      )}
                                    </div>

                                    <div className='d-flex flex-column'>
                                      {(() => {
                                        const personnel = personnels.find(
                                          (p) =>
                                            p.id === note.addedUserUid ||
                                            p.uid === note.addedUserUid
                                        )
                                        return (
                                          <span className='text-dark fw-bold fs-6'>
                                            {note.addedUser}
                                            {personnel && personnel.role && (
                                              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                                                {personnel.role}
                                              </span>
                                            )}
                                          </span>
                                        )
                                      })()}
                                      <span className='text-gray-600 fw-semibold text-muted d-block fs-7'>
                                        {note.addedDate} {note.addedTime}
                                      </span>
                                    </div>
                                  </div>

                                  <div className='dropdown'>
                                    {currentUser?.uid === note?.addedUserUid && (
                                      <button
                                        className='btn btn-secondary border-0 p-0 m-2'
                                        type='button'
                                        id='dropdownMenu2'
                                        data-bs-toggle='dropdown'
                                        aria-haspopup='true'
                                        aria-expanded='false'
                                      >
                                        <img
                                          src='/media/buttons/Options.svg'
                                          alt='Options'
                                          onClick={toggleDropdown}
                                        />
                                      </button>
                                    )}
                                    <ul
                                      className='dropdown-menu dropdown-menu-end'
                                      aria-labelledby='dropdownMenu2'
                                    >
                                      <li>
                                        <button
                                          className='dropdown-item text-hover-primary'
                                          type='button'
                                          style={{color: '#262626'}}
                                          onClick={() => handleEditNote(index, note.note)}
                                        >
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='18'
                                            height='18'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='currentColor'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                            className='icon icon-tabler icons-tabler-outline icon-tabler-edit mx-2 mb-1'
                                          >
                                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                            <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                                            <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                                            <path d='M16 5l3 3' />
                                          </svg>
                                          Edit
                                        </button>
                                      </li>
                                      <li>
                                        <button
                                          className='dropdown-item text-danger'
                                          type='button'
                                          onClick={() => handleDeleteNote(index)}
                                        >
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='18'
                                            height='18'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='currentColor'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                            className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                                          >
                                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                            <path d='M4 7l16 0' />
                                            <path d='M10 11l0 6' />
                                            <path d='M14 11l0 6' />
                                            <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                            <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                          </svg>
                                          Delete
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                {editingNoteIndex === index ? (
                                  <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <textarea
                                      value={editedNoteContent}
                                      onChange={(e) => setEditedNoteContent(e.target.value)}
                                      className='form-control'
                                    />
                                    <div
                                      className='d-flex justify-content-end w-100 mt-2 gap-2'
                                      style={{width: '100%'}}
                                    >
                                      <Button
                                        btnType='secondary'
                                        onClick={() => setEditingNoteIndex(null)}
                                      >
                                        Close
                                      </Button>
                                      <button
                                        onClick={handleSaveEditedNote}
                                        className='btn btn-sm fs-6'
                                        onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                                          (e.currentTarget.style.backgroundColor = '#148363')
                                        }
                                        onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                                          (e.currentTarget.style.backgroundColor = '#0E9F6E')
                                        }
                                        style={{
                                          backgroundColor: '#0E9F6E',
                                          color: '#fff',
                                          height: '40px',
                                          borderRadius: '4px',
                                          marginLeft: '4px',
                                          transition: 'background-color 0.3s',
                                        }}
                                      >
                                        {noteSaving ? (
                                          <>
                                            Saving...
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                          </>
                                        ) : (
                                          'Save'
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className='card p-4 mt-2'>
                                    <span className='d-block fs-6 text-gray-900'>{note.note}</span>
                                  </div>
                                )}
                                {/* <div className='card p-4 mt-2' style={{background: '#F6F6F6'}}>
                                  <span className='d-block fs-6' style={{color: '#5A5A5A'}}>
                                    {note.note}
                                  </span>
                                </div> */}
                              </div>
                            ))
                          ) : (
                            <div key='no-notes'></div>
                          )
                        })
                    ) : (
                      <div>No controls available</div>
                    )}
                  </div>
                </>
              )}

              <AddTask isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} control_id={id ?? ''} />

              {activeTab === 'tasks' && (
                <>
                  <div className='my-4 '>
                    <div className='fs-6 fw-bold mb-2'>Task List</div>
                    <span>Assign tasks that might fix this control to team members.</span>
                  </div>
                  <button
                    className='btn btn-sm '
                    onClick={() => setIsModalOpen(true)}
                    onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                      (e.currentTarget.style.backgroundColor = '#ECECEC')
                    }
                    onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                      (e.currentTarget.style.backgroundColor = '#fff')
                    }
                    // disabled={activities.length === 0}
                    style={{
                      backgroundColor: '#fff',
                      color: '#000',
                      width: '120px',
                      height: '40px',
                      borderRadius: '4px',
                      border: '2px solid #C5C5C5',
                      transition: 'background-color 0.3s',
                    }}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-plus mx-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M12 5l0 14' />
                      <path d='M5 12l14 0' />
                    </svg>
                    Add Task
                  </button>
                  <div className='card p-3 mt-4'>
                    {/* begin::Table container */}
                    <div
                      className='table-responsive'
                      style={{minHeight: '300px', maxHeight: '500px', overflowY: 'auto'}}
                    >
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='w-25px'>
                              <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  value='1'
                                  data-kt-check='true'
                                  data-kt-check-target='.widget-9-check'
                                  // checked={isChecked}
                                  // onChange={handleCheckboxChange}
                                />
                              </div>
                            </th>
                            <th className='min-w-200px'>Task</th>
                            <th className='min-w-50px'>Priority</th>
                            <th className='min-w-100px'>Assigned To</th>
                            {/* <th className='min-w-100px'>Due date</th> */}
                            <th className='min-w-50px text-end'></th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {tasks.map((task) => (
                            <tr key={task.id}>
                              <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    checked={task.checked}
                                    // onChange={() => handleTaskCheckboxChange(task.id)}
                                  />
                                </div>
                              </td>

                              <td>
                                <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                  {task.taskName}
                                </div>
                              </td>
                              <td>
                                <span className='badge border p-2 rounded-pill fs-6 fw-semibold'>
                                  <span
                                    className={`badge border rounded-circle mx-2  ${
                                      task.priority === 'High'
                                        ? 'bg-danger'
                                        : task.priority === 'Medium'
                                        ? 'bg-warning'
                                        : 'bg-primary'
                                    }`}
                                    style={{
                                      width: '12px',
                                      height: '12px',
                                      padding: '3px',
                                    }}
                                  >
                                    {' '}
                                  </span>

                                  {task.priority}
                                </span>
                              </td>
                              <td>
                                <div className='d-flex align-items-center'>
                                  {task.owner ? (
                                    <>
                                      <div className='symbol symbol-35px me-3'>
                                        <span
                                          className='symbol-label fs-7 fw-bold'
                                          style={{backgroundColor: '#DAF9EF'}}
                                        >
                                          {task.owner
                                            ? (() => {
                                                const nameParts = task.owner.split(' ')
                                                if (nameParts.length > 1) {
                                                  return `${nameParts[0]
                                                    .charAt(0)
                                                    .toUpperCase()}${nameParts[1]
                                                    .charAt(0)
                                                    .toUpperCase()}`
                                                } else {
                                                  return `${nameParts[0]
                                                    .charAt(0)
                                                    .toUpperCase()}${nameParts[0]
                                                    .charAt(1)
                                                    .toUpperCase()}`
                                                }
                                              })()
                                            : ''}
                                        </span>
                                      </div>
                                      <div className='d-flex justify-content-start flex-column'>
                                        <div className='text-dark fw-semibold text-hover-primary fs-6'>
                                          {task.owner}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <span>-</span>
                                    </>
                                  )}
                                </div>
                              </td>

                              {/* <td className='fs-6 fw-semibold'>{task.duedate}</td> */}
                              <td className='text-end'>
                                <div className='dropdown '>
                                  <button
                                    className='btn btn-secondary border-0 p-0 '
                                    type='button'
                                    id='dropdownMenu2'
                                    data-bs-toggle='dropdown'
                                    aria-haspopup='true'
                                    aria-expanded='false'
                                  >
                                    <img
                                      src='/media/buttons/Options.svg'
                                      alt='Options'
                                      // onClick={toggleDropdown}
                                    />
                                  </button>
                                  <ul className='dropdown-menu' aria-labelledby='dropdownMenu2'>
                                    <li>
                                      <button
                                        className='dropdown-item'
                                        type='button'
                                        // onClick={() => handleMarkAsComplete(task.id)}
                                      >
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          width='18'
                                          height='18'
                                          viewBox='0 0 24 24'
                                          fill='none'
                                          stroke='#5E6274'
                                          strokeWidth='2'
                                          strokeLinecap='round'
                                          strokeLinejoin='round'
                                          className='icon icon-tabler icons-tabler-outline icon-tabler-check mx-1 mb-1'
                                        >
                                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                          <path d='M5 12l5 5l10 -10' />
                                        </svg>{' '}
                                        Mark as complete
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className='dropdown-item'
                                        style={{color: '#F15363'}}
                                        type='button'
                                        onClick={() => handleRemoveTask(task.id)}
                                      >
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          width='18'
                                          height='18'
                                          viewBox='0 0 24 24'
                                          fill='none'
                                          stroke='#F15363'
                                          strokeWidth='2'
                                          strokeLinecap='round'
                                          strokeLinejoin='round'
                                          className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-1 mb-1'
                                        >
                                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                          <path d='M4 7l16 0' />
                                          <path d='M10 11l0 6' />
                                          <path d='M14 11l0 6' />
                                          <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                          <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                        </svg>{' '}
                                        Remove task
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </>
          ))
      ) : (
        <>
          {' '}
          <div style={{height: '80vh', display: 'flex', flexDirection: 'column'}}>
            {' '}
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          </div>
        </>
      )}
      <UpgradePlanTest show={showModal2} onClose={() => setShowModal2(false)} />
      <ToastContainer />
      <ConfirmationModal
        isModalOpen={isNoteDeleteModalOpen}
        hideModal={() => setIsNoteDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmNoteDelete}
        title='Delete Note'
        message='Are you sure you want to delete this note?'
        isLoading={isDeleting}
      />

      <ConfirmationModal
        isModalOpen={isTestDeleteModalOpen}
        hideModal={() => setIsTestDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmTestDelete}
        title='Delete Test Document'
        message='Are you sure you want to delete this test document?'
        isLoading={isDeleting}
        type='delete'
      />

      <ConfirmationModal
        isModalOpen={isPlatformDeleteModalOpen}
        hideModal={() => setIsPlatformDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmPlatformDelete}
        title='Delete Platform Test'
        message='Are you sure you want to delete this platform test?'
        isLoading={isDeleting}
        type='delete'
      />
      <ConfirmationModal
        isModalOpen={isControlDeleteModalOpen}
        hideModal={() => setIsControlDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmControlDelete}
        toDeleteItemTitle={selectedRisk?.riskSource}
        isLoading={isDeleting}
        title='Remove Control from Risk Scenario'
        message={`Are you sure you want to remove ${selectedRisk?.riskSource} control from risk scenario? This action cannot be undone.`}
        type='delete'
      />
      {isDeleteModalOpen && (
        <ConfirmationModal
          isModalOpen={isDeleteModalOpen}
          hideModal={() => setIsDeleteModalOpen(false)}
          confirmBtnClickHandler={handleConfirmTaskDelete}
          toDeleteItemTitle='selected task'
          isLoading={isDeleting}
          title='Remove Task'
          message='Are you sure you want to remove this task? This action cannot be undone.'
          type='delete'
          confirmButtonText='Remove'
        />
      )}
    </>
  )
}

export default DetailControl